module.exports = __webpack_public_path__ + "img/pure-escape_0.40f8c798.jpg";